import { render, staticRenderFns } from "./app-preview.vue?vue&type=template&id=5b79a2b2&scoped=true"
import script from "./app-preview.vue?vue&type=script&lang=js"
export * from "./app-preview.vue?vue&type=script&lang=js"
import style0 from "./app-preview.vue?vue&type=style&index=0&id=5b79a2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79a2b2",
  null
  
)

export default component.exports